/**
 * Bộ icon sidebar copy 1:1 từ mẫu design `plan/ERP CTRM Home.dc.html` (hướng 1a).
 * Icon stroke-style (Feather), vẽ bằng createSvgIcon để dùng như SvgIconComponent
 * trong config/navigation.ts. KHÔNG đổi path — muốn icon khác thì lấy tiếp từ mẫu.
 */
import { createSvgIcon } from '@mui/material/utils'

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const

export const NavHomeIcon = createSvgIcon(
  <g {...strokeProps}>
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </g>,
  'NavHome',
)

export const NavReportIcon = createSvgIcon(
  <g {...strokeProps}>
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </g>,
  'NavReport',
)

export const NavPurchaseContractIcon = createSvgIcon(
  <g {...strokeProps}>
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
  </g>,
  'NavPurchaseContract',
)

export const NavInboundIcon = createSvgIcon(
  <g {...strokeProps}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </g>,
  'NavInbound',
)

export const NavSaleContractIcon = createSvgIcon(
  <g {...strokeProps}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </g>,
  'NavSaleContract',
)

export const NavOutboundIcon = createSvgIcon(
  <g {...strokeProps}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </g>,
  'NavOutbound',
)

export const NavFuturesIcon = createSvgIcon(
  <g {...strokeProps}>
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </g>,
  'NavFutures',
)

export const NavMatchingIcon = createSvgIcon(
  <g {...strokeProps}>
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <line x1="3" y1="6" x2="3.01" y2="6" />
    <line x1="3" y1="12" x2="3.01" y2="12" />
    <line x1="3" y1="18" x2="3.01" y2="18" />
  </g>,
  'NavMatching',
)

export const NavFactoryIcon = createSvgIcon(
  <g {...strokeProps}>
    <path d="M3 21V10l4-3v3l4-3v3l5-3v11H3z" />
    <path d="M10 21v-4h4v4" />
  </g>,
  'NavFactory',
)

export const NavQualityIcon = createSvgIcon(
  <g {...strokeProps}>
    <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </g>,
  'NavQuality',
)

// Virtual Warehouse không có trong mẫu — dùng feather "archive" cùng ngôn ngữ stroke.
export const NavWarehouseIcon = createSvgIcon(
  <g {...strokeProps}>
    <polyline points="21 8 21 21 3 21 3 8" />
    <rect x="1" y="3" width="22" height="5" />
    <line x1="10" y1="12" x2="14" y2="12" />
  </g>,
  'NavWarehouse',
)

export const NavMasterDataIcon = createSvgIcon(
  <g {...strokeProps}>
    <ellipse cx="12" cy="5" rx="9" ry="3" />
    <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
  </g>,
  'NavMasterData',
)

export const NavSettingsIcon = createSvgIcon(
  <g {...strokeProps}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
  </g>,
  'NavSettings',
)
